import { tooltip } from "leaflet";
import { getSolidHumidityField, round, showSolidHumidity, ShowWindDirectInRumb } from "./helpers";

export const PRESSURE_HG_TO_MM = 0.750062;

const References = {

    "title": "Эмерсит - Краснодарский край",

    "dictionary": {
        "undef": "Не определено",        
        "not_configured": "Не настроен",
        "invalid_auth": "Пользователя с указанными данными не найдено",
        "no_canal_settings": "Параметры канала не заданы",
        "escalade": "Эскалация",
        "deescalade": "Деэскалация",
        "time": "Время",
        "accept": "Применить",
        "reset": "Сбросить",
        "reset_all": "сбросить все",
        "all": "все",
        "select_all": "выбрать все",
        "filter": "фильтр",
        "next": "Следующее",
        "prev": "Предыдущее",
        "close": "Закрыть",
        "full_screen": "Полный экран",
        "full_screen_exit": "Выход из полноэкранного режима",
        "filter_events": {
            "date": "Дата",
            "mch": "Канал",
            "station": "Пост"
        },
        "min": "Мин",
        "low": "Мин",
        "max": "Макс",
        "high": "Макс",
        "avg": "Сред",
        "sum": "Сумма",
        "or": "ИЛИ",
        "and": "И",
        "stations": "Посты",
        "agg": {
            '12H': '12 часов',
            'D': 'День',
            'E': 'Декада',
            '1M': 'Месяц',
            'A': 'Сезон',
            'Y': 'Год'            
        },
        "precipitation_label": [
            "Взвесь/туман",
            "Морось, мелкий дождь",
            "Дождь",
            "Сильный дождь",
            "Ливень",
            "Сильный ливень",
            "Очень сильный ливень",
            "Катастрофические осадки"
        ],
        "precipitation_agregate_label": {
            "10M": "10 минут",
            "1H": "1 час",
            "3H": "3 часа",
            "12H": "12 часов"
        },
        "precipitation_type_label": {
            "liquid": "жидкие",
            "solid": "твердые"
        },
        "preciptation_rolling_label": {
            "rolling": "скользящее окно",
            "discrete": "дискретные"
        },
        "settings_title": {
            "pressure": "Единицы измерения атмосферного давления",
            "wind": "Единицы измерения направления ветра"
        },
        "soil_humidity_depth_unit": "см",
        "soil_temperature_depth_unit": "см",
        "adc": "АЦП",
        
        "turn_theme_light": "Переключить на светлую тему",
        "turn_theme_dark": "Переключить на темную тему",
        "turn_maintained": "Переключить на обслуживаемые посты",
        "turn_maintained_all": "Переключить на все посты",
        "turn_view_short": "Переключить на сокращенный интерфейс",
        "turn_view_long": "Переключить на полный интерфейс",
        "turn_project_group": "Переключить на группы",
        "turn_project_area": "Переключить на регионы",

        "event_no_data": 'Выводить событий перехода в состояние "НЕТ ДАННЫХ"',

        "table": {
            emptyText: "Данных не найдено"
        },
        "event_situation_table": "Сводная таблица событий",
        "event_situation_empty": "Нет событий",

        "monthes": [
            "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
        ],
        "monthes_case": [
            "Января", "Февраля", "Марта", "Апреля", "Мая", "Июня", "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"
        ],
        "tooltips": {
            "button_station_legend": "Справка по уровням опасности состояния постов",
            "button_login": "Авторизация",
            "button_logout": "Выйти",
            "button_filter_station_mchs": "Фильтр постов по измерительным каналам",
            "button_filter_station_area": "Фильтр по принадлежности поста (муниципальное образование или юридическое лицо, за которыми закрпелен пост)",
            "button_search_station": "Поиск поста по номеру",
            "button_open_menu": "Открыть меню",
            "button_hide_menu": "Закрыть меню",
            "button_go_event": "Перейти к списку событий",
            "button_go_report": "Перейти к отчетам",
            "button_go_map": "Перейти к карте",
            "button_layers": "Меню выбора слоев",
            "button_lk": "Личный кабинет"
        },
        "station": "Пост",
        "mch": "Измерительный канал",
        "basis": "Базис"
    },

    "map": {
        "center": [45.035470, 38.975313],
        "zoom": {
            "default": 8,
            "min": 7,
            "max": 13,
        },
        "zoomBig": 10,
/*        "maxZoom": 13,
        "minZoom": 7,*/
        "tiles": "https://ngw.fppd.cgkipd.ru/tile/56/{z}/{x}/{y}.png",
//        "tiles": "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
        "tileOpacity": 0.5,
        "tile_layer": {
            "xyz_source": "https://ngw.fppd.cgkipd.ru/tile/56/{z}/{x}/{y}.png",
            "attribution": {	
                "href":	"https://portal.fppd.cgkipd.ru",
                "name":	"Карта ФППД"
            }
        }
    },

    "default_user": {
        "user": "user_anon",
        "password": "36985"
    },

    "pressure": {
        "units": {
            "gPa": "гПа",
            "mm": "мм рт. ст."
        },
        "convert": {
            "mm": (value) => Number(value) * 0.750062
        }
    },

    // Справочник пользовательских настроек
    "settingsCatalog": {
        "setting_wind_unit": {
            "key": "setting_wind_unit",
            "default": "rumbs",
            "type": "string",
            "serverSave": true,
            "options": [
                { "value": "rumbs", "label": "Румбы" },
                { "value": "rumbs_degrees", "label": "Румбы и градусы" }
            ]
        },

        "setting_pressure_unit": {
            "key": "setting_pressure_unit",
            "default": "gPa",
            "type": "string",
            "serverSave": true,
            "options": [
                { "value": "gPa", "label": "Гектопаскали" },
                { "value": "mm", "label": "Миллиметры ртутного столба" }
            ]
        },

        "setting_holder_filter": {
            "key": "setting_holder_filter",
            "default": 0,
            "type": "int",
            "serverSave": false
        }
    },

    "seasons": {
        "1": "Зима",
        "2": "Весна",
        "3": "Лето",
        "4": "Осень"
    },
    "state_undef": -2,   

    "refresh": 10,
    "tooltip_delay": 1,

    "locale": "ru-RU",
    "dateFormat": 'DD/MM/YYYY',
    "localeDateFormat": "DD.MM.YYYY",
    "dateTimeFormat": 'DD/MM/YYYY HH:00:00',
    "dateHourFormat": 'DD.MM.YYYY HH:00',
    "dateHourMinuteFormat": 'DD.MM.YYYY HH:mm',
    "shortDateFormat": "DD.MM HH:mm",
    "onlyDateFormat": "MM.DD.YYYY",    
    "default_chart_color": "#00a",

    "no_data_code": -2,
    "api": {
        "actual": "/api/actual/",
        "data": "/api/%s/%s/%s/?dtime_from=%s&dtime_to=%s",
        "group": "/api/mch_group/%s/?dtime_from=%s&dtime_to=%s",
        "data_normalization": "/api/normalization/%s/%s/%s/?dtime_from=%s&dtime_to=%s&normalize_method=%s",
        "geo": "/geoserver/pg/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=pg%3Amch_%s_threat&maxFeatures=50&outputFormat=application%2Fjson&CQL_FILTER=obj_type=1",
        "akb": "/api/akb",
        "detail_akb": "api/sensors/%s/%s/?dtime_from=%s&dtime_to=%s",
        "detail_station": "api/sensors/tech/%s/?dtime_from=%s&dtime_to=%s",
        "login": "/api/token/",
        "logout": "/api/token/logout/",
        "logout_all": "/api/token/logout_all/",        
        "check": "api/token/verify/",
        "refresh": "api/token/refresh/",
        "prec_triangle": "api/precipitation_triangulation/?dtime_from=%s&step=10.0",
        "analytic": "/api/mchs/%s/%s/?dtime_from=%s&dtime_to=%s&period=%s&func=min,max,avg,sum,start,end",
        "get_photos": "api/mchs/photo/%s/?dtime_from=%s&dtime_to=%s",
        "get_photo": "/api/getphoto/mchs/%s/%s",
        "area": "/api/holders",
        "get_precipitation_field": "/api/geo/field/precipitationfield/d50095f9-b2f7-44f7-8055-494f52535d47/?dtime_from=%s&dtime_to=%s&start_lat=%s&start_lon=%s&end_lat=%s&end_lon=%s&zoom=%s&step=4000",        
        "event_situation_summary": "/api/events_feed/situation/?dtime=%s",
        "event_filtered": "/api/events_feed/situation/events/?dtime_from=%s&dtime_to=%s",
        "event_integral": "/api/events_feed/integral/?dtime=%s",
        "report_mch": "api/reports/hpj/measurement/",
        "report_mch_station": "/api/reports/measurement/stations/",
        "report_sheet": "/api/reports/hpj/statement/",
        "report_sheet_station": "/api/reports/statement/stations/",
        "report_precipitation": "/api/reports/hpj/precipitation/",
        "report_precipitation_holders": "/api/reports/precipitation/holders/"        
        //"event_situation_summary": "/api/events_feed/situation/?dtime_from=%s&&dtime_to=%s"
        //"get_precipitation_field": "/api/geo/field/precipitationfield/d50095f9-b2f7-44f7-8055-494f52535d47/?dtime_from=2025-01-04T14:00:00%2B03:00&dtime_to=2025-01-05T07:00:00%2B03:00&start_lat=44.413736&start_lon=38.514901&end_lat=44.851123&end_lon=39.615187&zoom=10&step=4000"
    },

    "tabsChannels": [
        {
            type: "mchs",
            name: "Каналы"
        },
        {
            type: "event",
            name: "События",

        },
        {
            type: "photo",
            name: "Фото"
        },
        {
            type: "description",
            name: "Описание"
        }
    ],

    colors: ["rgb(50, 205, 50)", "rgb(255, 140, 0)", "rgb(255, 105, 180)", "rgb(255, 215, 0)", "rgb(0, 206, 209)", "rgb(128, 128, 0)", "rgb(255, 0, 0)", "rgb( 0, 255, 0)", "rgb(128, 0, 211)", "rgb(128, 0, 211)"],

    "sensors": {
        "voltage12": {
            "name": "Напряжение 12В",
            "precision": 2,
            "field": "voltage12",
            "unit": "В"
        },

        "voltage4": {
            "name": "Напряжение 4В",
            "precision": 2,
            "field": "voltage4",
            "unit": "В"
        },


        "precipitation": {
            "name": "Осадки (РЛ)",
            "precision": 1,
            "field": "precipitation_10m",
            "unit": "мм"

        },
        "precipitationtic": {
            "name": "Осадки (имп)",
            "precision": 1,
            "field": "precipitation_10m",
            "unit": "мм"
        },
        "rldistance": {
            "name": "Уровнемер (РЛ)",
            "precision": 3,
            "field": "ndistance",
            "unit": "м"
        },

        "usdistance": {
            "name": "Уровнемер (УЗ)",
            "precision": 3,
            "field": "ndistance",
            "unit": "м"
        },

        "hsdistance": {
            "name": "Уровнемер (Гидростатика)",
            "field": "ndistance",
            "precision": 3,            
            "unit": "м"
        },

        "lzdistance": {
            "name": "Уровнемер (Лазер)",
            "field": "ndistance_mm",
            "precision": 3,            
            "unit": "мм"            
        },

        "temperaturetech": {
            "name": "Температура (тех)",
            "precision": 1,
            "field": "temperature",
            "unit": "°C"
        },
        "temperature": {
            "name": "Температура",
            "precision": 1,
            "field": "temperature",
            "unit": "°C"
        },
        "humidity": {
            "name": "Влажность",
            "precision": 0,
            "field": "humidity",
            "unit": "%"
        },
        "pressure": {
            "name": "Давление",
            "precision": 0,
            "field": "pressure_abs",
            "unit": "гПа"
        },
        "dewpoint": {
            "name": "Точка росы",
            "precision": 1,
            "field": "dew_point",
            "unit": "°C"
        }
    },

    "mchs": {
        "waterlevel": {
            "name": "Уровень воды",
            "precision": 3,
            "field": "bs",
            "unit": "м, БСВ",
            "const_lines": {
                "flooding_prevention": {
                    "name": "НЯ затопления",
                    "color": "rgb(240, 140, 17)"
                },
                "flooding_danger": {
                    "name": "ОЯ затопления",
                    "color": "rgb(199, 22, 30)"
                },
                "draining_prevention": {
                    "name": "НЯ осушения",
                    "color": "rgb(240, 140, 17)"
                },
                "draining_danger": {
                    "name": "ОЯ осушения",
                    "color": "rgb(199, 22, 30)"
                },
                "dry": {
                    "name": "Уровень сухого дна",
                    "color": "rgba(0, 0, 200, 0.25)"
                }
            },
            "settings": {
                "flooding_prevention": {
                    "name": "НЯ затопления",
                },
                "flooding_danger": {
                    "name": "ОЯ затопления",
                },
                "draining_prevention": {
                    "name": "НЯ осушения",
                },
                "draining_danger": {
                    "name": "ОЯ осушения",
                },
                "fix": {
                    "name": "Уровень датчика"
                },
                "dry": {
                    "name": "Уровень сухого дна"
                }
            },
            "analytic": {
                "high": "bs_max",
                "low": "bs_min",
                "open": "bs_min",
                "close": "bs_max",
                "avg": "bs_avg",
                "datasets": ["high", "low", "avg"]
            },  
            "basis": 
                {"bsv": {
                    "field": "bs",
                    "label": "БСВ",
                    "unit": "м, БСВ"
                },
                "zero": {
                    "field": "zero",
                    "label": "Ноль гидропоста",
                    "unit": "м",
                    "unit_diff": {
                        "fix": "м, БСВ"
                    }

                }
            },          
            min: true,
            max: true,
            icons_index: 0,
            callbackname: "waterlevel"
        },
        "waterleveldifference": {
            "name": "Разница уровней воды",
            "field": "difference",
            "precision": 3,
            "unit": "м",
            "min": true,
            "max": true
        },

        "gateposition": {
            "name": "Положение затвора",
            "precision": 1,
            "field": "position",
            "unit": "см",
            "max": true,
            "min": true,
            "settings": {
                "min_position": {
                    "name": "Минимум"
                },
                "max_position": {
                    "name": "Максимум"
                }
            },
            "tooltips": true,
            "extInfo": true,
            "extInfoField": "percent", 
            "extInfoCalc": (val) => {return round(val, 1)},           
            "extInfoName": "Процент",  
            "extInfoUnit": "%",

        },      
        "waterdischarge": {
            "name": "Расход воды",
            "agg_name": "Объем воды",            
            "precision": 3,
            "field": "discharge",
            "unit": "м³/с",
            "analytic": {
                "high": "discharge_sum",
                "low": 0,
                "sum": "discharge_sum",                
                "datasets": ["sum"],
                "precision": 0,                
                "unit": "м3"                
            },

            "settings": {
                "min_bs": {
                    "name": "Мин. уровень расчета",
                },
                "max_bs": {
                    "name": "Макс. уровень расчета",
                },
                "min_discharge": {
                    "name": "Мин. расход воды"                      
                },
                "max_discharge": {
                    "name": "Макс. расход воды"
                }
            },                  
            min: true,
            max: true           
        },
        "waterdischarge2d": {
            "name": "Расход воды",
            "agg_name": "Объем воды",            
            "precision": 2,
            "field": "discharge",
            "unit": "м³/с",                
            min: true,
            max: true,
            "analytic": {
                "low": 0,
                "high": "discharge_sum",
                "datasets": ["sum"],
                "sum": "discharge_sum",   
                "precision": 0,  
                "unit": "м3"                                                           
            },            
            "settings": {
                "min_z_bs": {
                    "name": "Мин. напор",
                    "unit": "м"
                },
                "max_z_bs": {
                    "name": "Макс. напор",
                    "unit": "м"
                },
                "min_h": {
                    "name": "Мин. высота затвора",
                    "unit": "м"
                },
                "max_h": {
                    "name": "Макс. высота затвора",
                    "unit": "м"
                }
            }           
        },  
        "waterflow": {
            "name": "Счетчик воды",
            "field": "water_flow_total",
            "precision": 0,
            "unit": "м3"
        },
        "waterdischargeflow": {
            "name": "Расход воды",
            "agg_name": "Объем воды",
            "field": "discharge",
            "precision": 2,
            "unit": "м³/с",
            min: true,
            max: true,             
            "analytic": {
                "high": "discharge_sum",
                "low": 0,
                "sum": "discharge_sum",                
                "datasets": ["sum"],
                "precision": 0,
                "unit": "м3"
            },            
        },
        "watervelocity": {
            "name": "Скорость течения",
            "precision": 3,
            "field": "average_velocity",
            "unit": "м/с"            
        },
        "precipitation": {
            "name": "Осадки",
            "precision": 1,
            "field": "precipitation_10m",
            "aggregate_field": "precipitation_10m_sum",
            "unit": "мм",
            "intens_unit": "мм/ч",
            "chart_type": "bar",
/*            "point_icons": {
                "function": "precipitaionIcons",
                "field": "precipitation_type_code"
            },*/

            "bar_colors": {
                "function": "precipitationColor",
                "field": "precipitation_type_code",
                "colors": {
                    40: "rgb(50, 53, 58)",
                    60: "rgb(0, 40, 71)",
                    67: "rgb(50, 58, 85)",
                    69: "rgb(55, 76, 91)",
                    70: "rgb(80, 87, 97)",
                    90: "rgb(0, 12, 28)"                    
               },
            icons_index: 1
            },

            tooltips: {
                    40: "Не определен",
                    60: "Дождь",
                    67: "Ледяной дождь",
                    69: "Мокрый снег",
                    70: "Снег",
                    90: "Град"                    

            },

            "max": true
        },
        "precipitationduo": {
            "name": "Осадки",
            "precision": 1,
            "field": "precipitation_10m",
            "unit": "мм",
            "chart_type": "bar",
            "bar_colors": {
                "function": "precipitationColor",
                "field": "precipitation_type_code",
                "colors": {
                    40: "rgb(50, 53, 58)",
                    60: "rgb(0, 40, 71)",
                    67: "rgb(50, 58, 85)",
                    69: "rgb(55, 76, 91)",
                    70: "rgb(80, 87, 97)",
                    90: "rgb(0, 12, 28)"                    
               },
            },
            "settings": {
                "intensity_prevention": {
                    "name": "НЯ",
                    "unit": "мм"
                },
                "intensity_danger": {
                    "name": "ОЯ",
                    "unit": "мм"
                },
                "intensity_prevention_1h_liquid": {
                    "name": "НЯ (жидкие осадки за 1 час)",
                    "unit": "мм"
                },
                "intensity_danger_1h_liquid": {
                    "name": "ОЯ (жидкие осадки за 1 час)",
                    "unit": "мм"
                },

                "intensity_prevention_1h_solid": {
                    "name": "НЯ (твредные осадки за 1 час)",
                    "unit": "мм"
                },                
                "intensity_danger_1h_solid": {
                    "name": "ОЯ (твердые осадки за 1 час)",
                    "unit": "мм"
                },
                "intensity_prevention_3h_liquid": {
                    "name": "НЯ (жидкие осадки за 3 часа) ",
                    "unit": "мм"
                },
                "intensity_danger_3h_liquid": {
                    "name": "ОЯ (жидкие осадки за 3 часа)",
                    "unit": "мм"
                },
                "intensity_prevention_3h_solid": {
                    "name": "НЯ (твердые осадки за 3 часа)",
                    "unit": "мм"
                },
                "intensity_danger_3h_solid": {
                    "name": "ОЯ (твердые осадки за 3 часа) ",
                    "unit": "мм"
                },
                "intensity_prevention_12h_liquid": {
                    "name": "НЯ (жидкие осадки за 12 часов)",
                    "unit": "мм"
                },
                "intensity_danger_12h_liquid": {
                    "name": "ОЯ (жидкие осадки за 12 часов) ",
                    "unit": "мм"
                },
                "intensity_prevention_12h_solid": {
                    "name": "НЯ (твердые осадки за 12 часов)",
                    "unit": "мм"
                },
                "intensity_danger_12h_solid": {
                    "name": "ОЯ (твердые осадки за 12 часов) ",
                    "unit": "мм"
                },                                                                                                                                                
            },
            tooltips: {
                    40: "Не определен",
                    60: "Дождь",
                    67: "Ледяной дождь",
                    69: "Мокрый снег",
                    70: "Снег",
                    90: "Град"                    

            },
/*            "point_icons": {
                "function": "precipitaionIcons",
                "field": "precipitation_type_code"
            },*/
            "max": true

        },

        "precipitationduocomplex": {
            "name": "Осадки (индикаторы)",
            "precision": 1,
            "field": "precipitation_accumulated",
            "unit": "мм",
            "chart_type": "no",
        },

        "temperature": {
            "name": "Температура",
            "precision": 1,
            "field": "temperature",
            "unit": "°C",
            "max": true,
            "min": true,
            "analytic": {
                "high": "temperature_max",
                "low": "temperature_min",
                "open": "temperature_start",
                "close": "temperature_end",
                "avg": "temperature_avg",
                "datasets": ["high", "low", "avg"]
            }
        },
        "temperaturewater": {
            "name": "Температура воды",
            "precision": 1,
            "field": "temperature",
            "unit": "°C",
            "max": true,
            "min": true,
        },

        "humidity": {
            "name": "Влажность",
            "precision": 0,
            "field": "humidity",
            "unit": "%",
            "min": true,
            "max": true,
            "analytic": {
                "high": "humidity_max",
                "low": "humidity_min",
                "open": "humidity_start",
                "close": "humidity_end",
                "avg": "humidity_avg",
                "datasets": ["high", "low", "avg"]
            }
            
        },
        "pressure": {
            "name": "Давление",
            "precision": 0,
            "field": "pressure_abs",
            "unit": "гПа",
            "min": true,
            "max": true,
            "analytic": {
                "high": "pressure_abs_max",
                "low": "pressure_abs_min",
                "open": "pressure_abs_start",
                "close": "pressure_abs_end",
                "avg": "pressure_abs_avg",
                "datasets": ["high", "low", "avg"]
            }
            
        },
        "dew_point": {
            "name": "Точка росы",
            "precision": 1,
            "field": "dew_point",
            "unit": "°C"
        },
        "wind": {
            "name": "Направление и скорость ветра",
            "short_name": "Скорость ветра",
            "precision": 1,
            "field": "speed_avg",
            "unit": "м/с",
            "chart_type": [
                {"polar": "Роза ветров"},
                {"line": "График"}
            ],
            "tooltips": 1,
            "extInfo": "windDirect",
            "extInfoField": "direction_avg",
            "extInfoCalc": (val) => { return ShowWindDirectInRumb(val) },
            "extInfoName": "Направление ветра",
            "extInfoUnit": "",
            "extInfoRumbUnit": "румбы",
            "extInfoDegreesUnit": "°",
            "polar": {
                "limits": [0.3, 1.5, 3.3, 5.4, 7.9, 10.7, 13.8, 17.1, 20.7, 24.4, 28.4, 32.6],
                "limits_colors": ["#EEE", "#AEF1F9", "#96F7DC", "#96F7B4", "#6FF46F", "#73ED12", "#A4ED12", "#DAED12", "#EDC212", "#ED8F12", "#ED6312", "#ED2912", "#D5102D"],
                "show_limits": true,
                "polar_field": "direction_avg",
                "polar_labels": ['С', 'ССВ', 'СВ', 'СВВ', 'В', 'ЮВВ', 'ЮВ', 'ЮЮВ', 'Ю', 'ЮЮЗ', 'ЮЗ', 'ЮЗЗ', 'З', 'СЗЗ', 'СЗ', 'ССЗ'],
                "polar_limits_calc": (val) => { return Math.floor( val / 22.5 ) }
            },
            "min": true
        },
        "windgust": {
            "name": "Скорость порывов ветра",
            "precision": 1,
            "field": "speed_gust",
            "unit": "м/с",
            "min": true
        },
        "gas20m": {
            "name": "Концентрация газов (разовая)",
            "precision": 3,
            "field": "concentration_20m",
            "unit": "мг/м³",
            "const_lines": {
                "mpc_l": {
                    "name": "ПДК жилой зоны, мг/м³",
                    "color": "rgb(240, 140, 17)"
                },
                "mpc_w": {
                    "name": "ПДК рабочей зоны, мг/м³",
                    "color": "rgb(199, 22, 30)"
                }
            },
            "settings": {
                "mpc_l": {
                    "name": "ПДК жилой зоны, мг/м³",
                },
                "mpc_w": {
                    "name": "ПДК рабочей зоны, мг/м³",
                }
            },
            max: true
        },        

        "gas24h": {
            "name": "Концентрация газов (среднесуточная)",
            "precision": 3,
            "field": "concentration_24h",
            "unit": "мг/м³",
            "const_lines": {
                "mpc_l": {
                    "name": "ПДК жилой зоны, мг/м³",
                    "color": "rgb(240, 140, 17)"
                },
                "mpc_w": {
                    "name": "ПДК рабочей зоны, мг/м³",
                    "color": "rgb(199, 22, 30)"
                }
            },
            settings: {
                "mpc_l": {
                    "name": "ПДК жилой зоны",
                    "color": "rgb(240, 140, 17)"
                },
                "mpc_w": {
                    "name": "ПДК рабочей зоны",
                    "color": "rgb(199, 22, 30)"
                }
            },
            max: true
        },     

        "radiation": {
            "name": "Радиация",
            "precision": 3,
            "field": "radiation",
            "unit": "мкЗв/ч",
            "const_lines": {
                "radiation_prevention": {
                    "name": "НЯ",
                    "color": "rgb(240, 140, 17)"
                },
                "radiation_danger": {
                    "name": "ОЯ",
                    "color": "rgb(199, 22, 30)"
                }
            },
            "settings": {
                "radiation_prevention": {
                    "name": "НЯ",
                },
                "radiation_danger": {
                    "name": "ОЯ",
                }
            },
            "extInfo": "radiationUncertainty",
            "extInfoField": "uncertainty",
            "extInfoCalc": (val) => {return Math.round(val)},
            "extInfoName": "Неопределенность",  
            "extInfoUnit": "%",      
            tooltips: 1,
            max: true            
        },

        "radiationglobal": {
            "name": "Солнечная радиация",
            "precision": 3,
            "field": "global_radiation_avg",
            "unit": "Вт/м²"
        },

        "soilhumidity": {
            "name": "Влажность почвы",
            "precision": 1,
            "field": getSolidHumidityField,
            "field_common": "soil_humidity",
            "field_percent": "soil_humidity_percent",
            "unit": "%",

            "tooltips": 1,             
            "extInfo_hum": {
                "field1": "adc1",
                "name1": "АЦП 1",
                "field2": "adc2",
                "name2": "АЦП 2",
                "unit": "мВ",
                "prec": 0
            },

            "settings": {
                "depth": {
                    "name": "Глубина установки",
                    "unit": "м",
                    "prec": 2
                }
            }
        },

        "soiltemperature": {
            "name": "Температура почвы",
            "precision": 1,
            "field": "soil_temperature",
            "unit": "°С",

            "tooltips": 1,
            "settings": {
                "depth": {
                    "name": "Глубина установки",
                    "unit": "м",
                    "prec": 2
                }
            }
        },
        "wave": {
            "name": "Волнение моря",
            "field": "wave_h_avg",
            "precision": 3,
            "unit": "м",
            "tabs": [
                {
                    "title": "Высота волны",
                    "source": ["wave_h_avg", "wave_h_max"],
                    "color": ["#00a", "red"],
                    "labels": ["Сред", "Макс"],
                    "precision": "3",
                    "unit": "м"
                },
                {
                    "title": "Период волны",
                    "source": ["wave_t_avg", "wave_t_max"],
                    "color": ["#00a", "red"],                    
                    "labels": ["Сред", "Макс"],
                    "precision": "3",
                    "unit": "c"
                }
            
            ],
/*            "chart_type": [
                {"height": "Высота волны"},
                {"period": "Период волны"}
            ],          */
            "extInfo": true,
            "extInfoField": "wave_t_avg", 
            "extInfoCalc": (val) => {return round(val, 3)},           
            "extInfoName": "Период",  
            "extInfoUnit": " c",            
        },        

    }, 

    "door_state": {
        "0": {
            "text": "Открыта",
            "color": "rgb(201, 33, 30)",
        },
        "1": {
            "text": "Закрыта",
            "color": "rgb(94, 185, 30)"
        },
        "default": {
            "text": "Нет данных",
            "color": "rbg( 128, 128, 128)"
        }
    },

    "danger": {
        "default": {
            "short": "НД",            
            "title": "Нет данных",
            "color": "rgb(127, 127, 127)",
            "alt_color": "rgb(110, 110, 100)"
        },
        "-2": {
            "short": "НД",            
            "title": "Нет данных",
            "color": "rgb(127, 127, 127)",
        },
        "0": {
            "short": "НОРМ",            
            "title": "Нормальное состояние",
            "color": "rgb(0, 160, 60)",
        },
        10: {
            "short": "ПВ",            
            "title": "Повышенное внимание",
            "color": "rgb(174, 235, 167)"
        },
        20: {
            "short": "ПО",            
            "title": "Потенциальная опасность",
            "color": "rgb(244, 207, 0)",
        },
        30: {
            "short": "НЯ",            
            "title": "Неблагоприятное явление",
            "color": "rgb(240, 140, 17)",
        },
        40: {
            "short": "ОЯ",            
            "title": "Опасное явление",
            "color": "rgb(199, 22, 30)",
        },
    },

    dangers: {
        "unknown": -2,
        "normal": 0,
        "pv": 10,
        "po": 20,
        "nya": 30,
        "oya": 40
    },

    "states": {
        "default": {
            "short": "НД",
            "title": "Нет данных"
        },

        "-1": {
            "short": "НД",
            "title": "Нет данных"
        },

        0: {
            "short": "НОРМ",
            "title": "Нормальное состояние"
        },

        "waterlevel": {
            110105: {
                "short": "СД",
                "title": "Сухой датчик. Уровень воды недостаточен для достоверного измерения"
            },                   
            110106: {
                "short": "ПВ",
                "title": "Повышенное внимание"
            },
            110107: {
                "short": "ПО",
                "title": "Потенциальная опасность"
            },            
            110110: {
                "short": "НЯ (о)",
                "title": "Неблагоприятное явление осушения"
            },
            110115: {
                "short": "НЯ",
                "title": "Неблагоприятное явление наводнения"
            },
            110120: {
                "short": "ОЯ (о)",
                "title": "Опасное явление осушения"
            },
            110125: {
                "short": "ОЯ",
                "title": "Опасное явление"
            }
        },
        "waterdischarge": {
            140110: {
                "short": "ОСУШ",
                "title": "Осушение. Уровень воды находится ниже предела расчета расхода"
            },
            140115: {
                "short": "ПРЛВ",
                "title": "Перелив. Уровень воды находится выше предела расчета расхода"
            }
        },
        "precipitationduo": {
            150110: {
                "short": "НЯ",
                "title": "Неблагоприятное явление"
            },
            150115: {
                "short": "ОЯ",
                "title": "Опасное явление"
            }
        },
        "precipitationduocomplex": {
            160110: {
                "short": "НЯ",
                "title": "Неблагоприятное явление"
            },
            160115: {
                "short": "ОЯ",
                "title": "Опасное явление"
            }            
        }
    },

    "tsmSyncStates": {
        "1" : {
            "bgColor": "rgb(201, 33, 30 )",
            "textColor": "rgb(255, 255, 255)"
        },
        "0": {
            "bgColor": "rgb(94, 185, 30)",
            "textColor": "rgb(0, 0, 0)"
        },
        "-1": {
            "bgColor": "rgb(255, 245, 206)",
            "textColor": "rgb(0, 0, 0)"
        },
        "default": {
            "bgColor": "rgb(255, 255, 255)",
            "textColor": "rgb(0, 0, 0)"
        },
        "dark": {
            "0": {
                "textColor": "rgb(0, 255, 0)"
            },
            "default": {
                "textColor": "rgb(255, 255, 255)"
            }
        }    
    },

    "tsmDoorStates": {
        "-1": "rgb(238, 238, 238)",
        "0": "rgb(229, 0, 0)",
        "1": "rgb(94, 185, 30)"
    },

    "akbVoltageStates": {
        "5": {
            bgColor: "rgb(229, 0, 0)",
            textColor: 'rgb(255, 255, 255)'
        },
        "4": {
            bgColor: "rgb(237, 13, 217)",
            textColor: 'rgb(255, 255, 255)'
        },
        "3": {
            bgColor: "rgb(255, 255, 0)",
            textColor: 'rgb(0, 0, 0)'
        },
        "2": {
            bgColor: "rgb(0, 0, 255)",
            textColor: 'rgb(255, 255, 255)'
        },
        "1": {
            bgColor: "rgb(192, 192, 192)",
            textColor: "rgb(0, 0, 0)"
        },
        "0": {
            bgColor: "rgb(94, 185, 35)",
            textColor: "rgb(0, 0, 0)",
            darkColor: "rgb(0, 255, 0)"
        },
        "-1": {
            bgColor: "rgb(255, 245, 206)",
            textColor: "rgb(0, 0, 0)"
        },
        "undefined": {
            bgColor: "rgb(255, 245, 206)",
            textColor: "rgb(0, 0, 0)"
        }
    },   
    
    "akbSignalStates": {
        "4": "rgb(94, 185, 30)",
        "3": "rgb(255, 255, 0)",
        "2": "rgb(255, 134, 13)",
        "1": "rgb(229, 0, 0)",
        "0": "rgb(140, 40, 30)",    
        "-1":"rgb(192, 192, 192)" ,
        "text_color": {
            "0": "rgb(255, 255, 255)",
            "1": "rgb(255, 255, 255)",
            "": "rgb(255, 255, 255)"
        },
        "dark": {
            "4": "rgb(0, 255, 0)"
        }
    },    
    
    "camStatuses": {
        "-1": {
            "text": "NODATA",
            "bgcolor": "rgb(127, 127, 127)"
        },
        "0": {
            "text": "NORM",
            "bgcolor": "rgb(0, 255, 255)"            
        },
        "1": {
            "text": "",
            "bgcolor": "rgb(110, 117, 14)"
        }
    },

    "system_mode_name": {
        "0": "GSM",
        "1": "LTE"
    },

    "voltageStatuses": [
        {
            "text": "Опасность",
            "value": "5"
        },
        {
            "text": "Предупреждение",
            "value": "4"
        },
        {
            "text": "Внимание",
            "value": "3"
        },
        {
            "text": "Проблема связи",
            "value": "2"
        },
        {
            "text": "Нет данных",
            "value": "1"
        },

    ],

    doorStatuses: [
        {
          text: ' Открыта ',
          value: 0,
        },
        {
          text: ' Закрыта ',
          value: 1,
        },
        {
          text: ' Нет данных ',
          value: 'default'
        },
      ],    

    event: {
        url: "/api/events/?dtime_from=%s&dtime_to=%s",
        situation: [
            "waterlevel", "precipitation"
        ],
        show_criteria: [
            "precipitation"
        ],
        criteria_field: {
            "10min": {
                field: "precipitation_10m",
                name: "10 мин"
            },
            "1h_liquid": {
                field: "precipitation_accumulated",
                name: "1 час (жидкие)",
                short_name: "1"
            },
            "1h_solid": {
                field: "precipitation_accumulated",
                name: "1 час (твердые)",
                short_name: "1"
            },
            "3h_liquid": {
                field: "precipitation_accumulated",
                name: "3 часа (жидкие)",
                short_name: "3"
                
            },
            "3h_solid": {
                field: "precipitation_accumulated",
                name: "3 часа (твердые)",
                short_name: "3"
            },
            "12h_liquid": {
                field: "precipitation_accumulated",
                name: "12 часов (жидкие)",
                short_name: "12"
            },
            "12h_solid": {
                field: "precipitation_accumulated",
                name: "12 часов (твердные)",
                short_name: "12"
            }
        },

        icons_index: {
            "waterlevel": 0, 
            "precipitationduo": 1,
            "precipitation": 1,
            "precipitationduocomplex": 1
        },
        groups: [
            {
                code: "waterdischarge",
                name: "Расход воды",
                mchs: ["waterdischarge", "waterdischarge2d", "waterdischargeflow"]
            },
            {
                code: "precipitation",
                name: "Осадки",
                mchs: ["precipitation", "precipitationduo", "precipitationduocomplex"]
            }
        ]
    },

    mchsFilter: {
        waterlevel: {
            title: "Уровень воды",
            name: "waterlevel",
            filter: ["waterlevel"]
        },       
        precipitation: {
            title: "Осадки",
            name: "precipitation",
            filter: ["precipitation", "precipitationduo", "precipitationduocomplex"]
        },
        meteo: {
            title: "Метео",
            name: "meteo",
            filter: ["temperature", "humidity", "pressure"]
        },
        wind: {
            title: "Ветер",
            name: "wind",
            filter: ["wind", "windgust"]
        },
        photo: {
            title: "Камера",
            name: "photo",
            filter: ["photo"]
        },
        waterdischarge: {
            title: "Расход воды",
            name: "waterdischarge",
            filter: ["waterdischarge", "waterdischarge2d", "waterdischargeflow"]
        },
        gas: {
            title: "Концентрация газа",
            name: "gas",
            filter: ["gas20m", "gas24h"]
        },
        radiation: {
            title: "Радиация",
            name: "radiation",
            filter: ["radiation"]
        },
        radiationglobal: {
            title: "Солнечная радиация",
            name: "radiationglobal",
            filter: ["radiationglobal"]
        },
        soilhumidity: {
            title: "Влажность почвы",
            name: "soilhumidity",
            filter: ["soilhumidity"]
        },
        waterflow: {
            title: "Счетчик объема воды",
            name: "waterflow",
            filter: ["waterflow"]
        },
        temperaturewater: {
            title: "Температура воды",
            name: "temperaturewater",
            filter: ["temperaturewater"]
        },
        wave: {
            title: "Волнение моря",
            name: "wave",
            filter: ["wave"]
        } 

    },

    normalizes_channels: [
        'waterlevel', 'waterdischarge'
    ],

    normalizes_methods: {
        no: "Исходные данные",
        rms_deviation: "Скользящее окно",
        rms_deviation_exclude: "Исключение значений"
    },

    layers: {
/*        "water_level": "Водотоки",
        "prec": "Водосборы",*/
        "prec_triangle": {
            title: "Поле осадков",
            controlsHeight: 70
        }
    },

    tsmExtraMCHS: {
        rldistance: {
            name: "Радиолокация",
            field: "ndistance"
        },
        usdistance: {
            name: "Ультразвук",
            field: "ndistance"
        },

        hsdistance: {
            name: "Гидростатика",
            field: "ndistance"
        },

        lzdistance: {
            name: "Лазер",
            field: "ndistance"
        }
    },

    tsmTableColumnWidth: {
        full: {
            region: {
                sn: "11%",
                akb_type: "4%",
                project: "28%",
                area: "14.5%",
                district: "13.5%",
                station: "6%",
                cam: "4%",
                voltage_day: "7%",
                voltage_night: "7%",
                door: "3.5%",
                signal_1: "3.5%",
                signal_2: "3.5%",
                signal_3: "3.5%",
                sync: "9.5%",
                online: "9.5%"
            },
            project: {
                sn: "12%",
                akb_type: "5%",
                project: "16%",
                area: "14.5%",
                district: "13.5%",
                station: "8%",
                cam: "5%",
                voltage_day: "9%",
                voltage_night: "9%",
                door: "4%",
                signal_1: "4%",
                signal_2: "4%",
                signal_3: "4%",
                sync: "10%",
                online: "10%"
            }

        },
        short: {
            region: {
                sn: "16%",
                akb_type: "5%",
                project: "38%",
                area: "19%",
                district: "19%",
                station: "6%",
                cam: "5%",
                voltage_day: "9.5%",
                voltage_night: "9.5%",
                online: "11%"
            },
            project: {
                sn: "16%",
                akb_type: "6%",
                project: "22%",
                area: "19%",
                district: "19%",
                station: "10%",
                cam: "8%",
                voltage_day: "13%",
                voltage_night: "13%",
                online: "12%"
            }
        }
    }

};

export default References;